import LogoutEscapeLink from "@/components/LogoutEscapeLink";
import Spinner from "@/components/ui/spinner";
import useGetUserProfile from "@/hooks/useGetUserProfile";
import { accountIdentityFromUserProfile } from "@/mappers/user/accountIdentityMapper";
import { useTranslation } from "react-i18next";
import NoLicenseOrganization from "./NoLicenseOrganization";
import NoLicenseView from "./NoLicenseView";
import OffersButton from "./OffersButton";

const NoLicenseScreen = () => {
    const { t } = useTranslation();
    const { data: userProfile, isLoading } = useGetUserProfile();

    if (isLoading || !userProfile) {
        return (
            <div className="relative flex h-screen w-full items-center justify-center">
                <Spinner />
                <div className="absolute inset-x-0 bottom-8 flex justify-center">
                    <LogoutEscapeLink variant="pillLight" />
                </div>
            </div>
        );
    }

    if (userProfile.teamId) {
        return <NoLicenseOrganization user={userProfile} />;
    }

    return (
        <NoLicenseView
            account={accountIdentityFromUserProfile(userProfile)}
            accountAction={
                <LogoutEscapeLink
                    className="shrink-0 text-purple-700"
                    variant="link"
                />
            }
            cta={<OffersButton />}
            description={t("noLicense.public.description")}
            title={t("noLicense.public.title")}
        />
    );
};

export default NoLicenseScreen;
